<template lang="pug">
  //- #pills-bet.tab-pane.fade(role="tabpanel" aria-labelledby="pills-bet-tab" :class="{'active show' : tabTarget === 'betHistory'}")
  #pills-bet.tab-pane.fade.active.show(role="tabpanel" aria-labelledby="pills-bet-tab")
    .d-lg-none
      .d-flex.history-single(v-for="ticket in betHistory")
        .flex-grow-1(v-if="checkBonus(ticket.result_id) == true")
          a.history-type(href="javascript:void(0);") {{ticket.result_id}} 
          | {{ ticket.game_name }}
        .flex-grow-1(v-else)
          a.history-type(href="javascript:void(0);" @click.stop="gameResult(ticket.result_id)") {{ticket.result_id}} 
          | {{ ticket.game_name }}
          .text-secondary.history-date {{ $moment(ticket.created_date).format("YYYY-MM-DD HH:mm:ss") }}
        .ml-2.text-small
          .text-right.font-weight-normal(v-if="ticket.winlose >= 0" :class="getColor(ticket.winlose)") WIN:
          .text-right.font-weight-normal(v-else :class="getColor(ticket.winlose)") LOSE:
        .ml-2.text-small
          .text-right.font-weight-normal(:class="getColor(ticket.winlose)") {{ $numeral(ticket.winlose).format("0,0.00") }}
    .d-none.d-lg-block
      .package-table.mb-0
        .row.table-row
          .col-2.text-left ID
          .col-2 Date 
          .col Game
          .col-2 Win/Lose
        .row.table-row(v-for="ticket in betHistory")
          .col-2.text-left(v-if="checkBonus(ticket.result_id) == true")
            a(href="javascript:void(0);") {{ticket.result_id}}
          .col-2.text-left(v-else)
            a(href="javascript:void(0);" @click.stop="gameResult(ticket.result_id)") {{ticket.result_id}}
          .col-2 {{ $moment(ticket.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
          .col {{ticket.game_name}}
          .col-2(:class="getColor(ticket.winlose)") {{ currencyCode }} {{ $numeral(ticket.winlose).format("0,0.00") }}
    .pagenumber.my-2
      paginate(
        v-if="!noHistory"
        :click-handler="changePage"
        :pageCount="pageCount"
        :page-range="4"
        :margin-pages="3"
        :prev-text="''"
        :next-text="''"
        :container-class="'p-0 m-0'"
        :page-class="'round'"
        :page-link-class="''"
        :prev-class="'round prev'"
        :next-class="'round next'"
        :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
        :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import Paginate from "vuejs-paginate";
export default {
  components: {
    Paginate
  },
  props:{
    tabTarget: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      working_date: "",
      currentPage: 1,
      feedback: {
        status: "",
        success: ""
      },
      pageSize: 10
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    appID() {
      return config.app_id;
    },
    currencyCode() {
      return this.$store.getters.currencyCode;
    },
    resultUrl() {
      return config.result_url;
    },
    betHistory() {
      return this.$store.getters.betHistory.data;
    },
    workingDate() {
      return this.$store.getters.betHistory.working_date;
    },
    noHistory() {
      if (this.$store.getters.betHistory.data) {
        if (this.$store.getters.betHistory.data[0]) {
          return false;
        }
      }
      return true;
    },
    pageCount() {
      if (!this.noHistory) {
        var test = this.$store.getters.betHistory.data[0].totalrows / 10;
        if (test % 1 != 0) {
          test = test + 1;
        }
        return Math.floor(test);
      } else {
        return 0;
      }
    }
  },
  destroyed() {},
  mounted() {},
  methods: {
    checkBonus(id){
      if(id.includes("RCB_") || id.includes("DCB_")){
        return true
      }else{
        return false
      }
    },
    gameResult(e) {
      window.open(
        config.result_url + e,
        "info",
        "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
      );
    },
    changePage(e) {
      this.currentPage = e;
      this.getMemberGameResult(this.workingDate, this.pageSize, e);
    },
    getMemberGameResult(working_date, page_size, page_number) {
      if (this.sessionToken) {
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        let app_id = this.appID;
        this.$store
          .dispatch("user/getMemberGameResult", {
            account_id,
            working_date,
            page_size,
            page_number,
            auth_token,
            app_id
          })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sBetHistory", {
                  data: response.data,
                  size: 10,
                  index: 1,
                  working_date: working_date
                })
                .then(() => {
                  $("#modal-statement").modal("hide");
                  $("#modal-bet-history").modal("show");
                })
                .catch(err => console.log(err));
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
            }
          });
      }
    },
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-color01";
      } else {
        return "text-white";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    }
  }
};
</script>
